<template>
  <CDropdown inNav class="c-header-nav-items" placement="bottom-end" add-menu-classes="pt-0">
    <template #toggler>
      <CHeaderNavLink>
        <div :title="username" class="c-avatar bg-primary text-white rounded-circle">
          {{ username[0] }}
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Account</strong> {{ username }}
    </CDropdownHeader>
    <CDropdownItem to="/account"> <CIcon name="cil-user" /> Profile </CDropdownItem>
    <CDropdownItem @click="logout()"> <CIcon name="cil-lock-locked" /> Logout </CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: 'TheHeaderDropdownAccnt',
  data() {
    return {
      itemsCount: 42,
    }
  },
  computed: {
    username: {
      get() {
        return this.$api.user && this.$api.user.name ? this.$api.user.name : ''
      },
    },
  },
  methods: {
    logout() {
      this.$api.logout()
    },
  },
}
</script>

<style scoped>
.c-avatar {
  text-transform: uppercase;
  font-weight: bold;
}
.c-icon {
  margin-right: 0.3rem;
}
</style>
